module.exports = __webpack_public_path__ + "templates.destination-section.family-mart-frozen-b2f734dd.html";